var dlsGray01Bg = {
  "backgroundColor": "#f7f8f9 !important"
};

export { dlsGray01Bg };
